import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Provider, useDispatch } from 'react-redux';
import store from '@/Redux/store';

import Welcome from './pages/welcome';
import QrCode from './pages/Auth/qrCode';
import Login from './pages/Auth/Login';
import Code2FA from './pages/Auth/Code2FA';
import P404 from './pages/ErrorBO';
import Unsub from './pages/Unsubscription';





const App = () => {


  return (   
      <Provider store={store}>
        <Router >
          <Routes>
            <Route path="/" element={<Welcome />} />;
            <Route path="/qrcode" element={<QrCode />} />;     
            <Route path="/login" element={<Login />} />;   
            <Route path="/code2fa" element={<Code2FA />} />; 
            <Route path="/unsub" element={<Unsub />} />;      
            <Route path="/404" element={<P404 />} />;          
            <Route path="*" element={<Welcome />} />
          </Routes>
        </Router>
      </Provider>    
  );
};

export default App;

